import ListStore from '../../../shared-lib/stores/ListStore'
import { $BookingLocation } from '../UserStore/UserStore'

import ExternalAddressModel from './ExternalAddressModel'

export type $ExternalAddressStore = ExternalAddressStore

export default class ExternalAddressStore extends ListStore<ExternalAddressModel> {
  fetchMethodName = 'externalAddresses'
  ModelClass = ExternalAddressModel

  fetchAddressesForBookingLocations = async (bookingLocations: $BookingLocation[]) => {
    await this.fetchItems_api({
      variables: {
        filter: {
          _ids: bookingLocations.map(location => location.addressId).filter(Boolean),
        },
      },
    })
  }
}
